export const INDEX_RULES_REGEX = [
  { label: 'A+', regex: /^[A-Z]$/ },
  { label: 'A0+', regex: /^[A-Z][0-9]$/ },
  { label: 'A00+', regex: /^[A-Z][0-9]{2}$/ },
  { label: 'AA+', regex: /^[A-Z]{2}$/ },
  { label: '0-A+', regex: /^[0-9A-Z]$/ },
];
